exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "textarea {\n  resize: none; }\n\n.mat-input-container {\n  margin-right: 42px;\n  margin-top: -8px;\n  margin-bottom: -12px; }\n\n@media (max-width: 600px) {\n  textarea.mat-input-element[_ngcontent-c3] {\n    overflow: hidden;\n    margin-bottom: -20px;\n    font-size: 9px;\n    margin-right: 12px; } }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/users/components/assign-role/assign-role.component.scss
// module id = 505
// module chunks = 5